<template>
  <!-- Dropdown para Selecionar Municípios -->
  <div style="display: flex; flex-direction: column; gap: 16px;">
    <!-- Contêiner das Tags com Scroll -->
    <div class="tags-wrapper">
      <div class="tags-container">
        <b-badge
          v-for="municipio in selectedMunicipios"
          :key="municipio"
          variant="info"
          class="tag-item"
          @click="removeTag(municipio)"
        >
          <span>{{ getMunicipioText(municipio) }}</span>
          <b-icon-x-circle class="ml-1"></b-icon-x-circle>
        </b-badge>
      </div>
    </div>

    <b-dropdown text="Selecione Municípios" variant="primary" class="mb-3">
      <b-dropdown-form>
        <!-- Campo de Busca -->
        <b-form-group label="Buscar Município:">
          <b-form-input
            v-model="search"
            placeholder="Digite para filtrar..."
            class="mb-2"
          ></b-form-input>
        </b-form-group>

        <!-- Lista com Scroll -->
        <div class="dropdown-scroll">
          <div v-if="isLoading" class="d-flex align-items-center mb-2">
            <b-spinner small type="grow" label="Carregando..." />
            <span class="ml-2">Carregando cidades...</span>
          </div>
          <b-form-checkbox
            v-for="municipio in filteredMunicipios"
            :key="municipio.value"
            @change="handleChange"
            v-model="selectedMunicipios"
            :value="municipio.value"
          >
            {{ municipio.text }}
          </b-form-checkbox>
        </div>
      </b-dropdown-form>
    </b-dropdown>
  </div>
</template>

<script>
import { Api } from '../../../../vue/api';
const API = new Api();

export default {
  name: 'MunicipioSelect',
  props: {
    value: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      municipiosOptions: [], // Opções carregadas do backend
      selectedMunicipios: this.value, // Municípios selecionados
      search: '', // Texto de pesquisa
      isLoading: false,
    };
  },
  computed: {
    filteredMunicipios() {
      // Filtra municípios com base na pesquisa
      if (!this.search) return this.municipiosOptions;
      return this.municipiosOptions.filter(municipio =>
        municipio.text.toLowerCase().includes(this.search.toLowerCase()),
      );
    },
  },
  async created() {
    const storedOptions = localStorage.getItem('municipioOptions');
    if (storedOptions) {
      this.municipiosOptions = JSON.parse(storedOptions);
      return;
    }
    await this.fetchMunicipios();
  },
  methods: {
    async fetchMunicipios() {
      this.isLoading = true;
      try {
        const { ok, model, errors } = await API.post('/execute', {
          path: `/lead-management/municipios`,
          method: 'get',
        });
        if (!ok) {
          this.$bvToast.toast(errors.message, {
            title: `Erro`,
            variant: 'error',
            solid: true,
          });
          return;
        }
        const options = model.map(municipio => ({
          value: municipio.code,
          text: `${municipio.code} - ${municipio.description}`,
        }));

        localStorage.setItem('municipioOptions', JSON.stringify(options));
        this.municipiosOptions = options;
      } catch (error) {
        this.$bvToast.toast(error.message, {
          title: 'Erro',
          variant: 'error',
          solid: true,
        });
      } finally {
        this.isLoading = false;
      }
    },

    removeTag(value) {
      this.selectedMunicipios = this.selectedMunicipios.filter(
        municipio => municipio !== value,
      );
      this.handleChange();
    },

    getMunicipioText(value) {
      const municipio = this.municipiosOptions.find(m => m.value === value);
      return municipio ? municipio.text : value;
    },
    handleChange() {
      this.$emit('input', this.selectedMunicipios);
    },
  },
};
</script>

<style scoped>
/* Dropdown Scroll */
.dropdown-scroll {
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #ddd;
  padding: 8px;
}

/* Wrapper para as tags */
.tags-wrapper {
  width: 400px; /* Largura Máxima */
  max-width: 400px;
  min-height: 40px;
  max-height: 80px; /* Altura Máxima */
  overflow-y: auto; /* Ativa scroll após atingir altura máxima */
  border: 1px solid #ddd;
  padding: 8px;
  border-radius: 4px;
  background-color: #f8f9fa;
}

/* Container das Tags */
.tags-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

/* Estilo individual das tags */
.tag-item {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 4px 8px;
  font-size: 14px;
  border-radius: 4px;
  background-color: #007bff;
  color: white;
  max-width: 100%;
  word-break: break-word;
}

.tag-item:hover {
  background-color: #0056b3;
}

.tag-item .b-icon-x-circle {
  margin-left: 5px;
}

/* Estilização para o campo de busca */
.b-form-input {
  margin-bottom: 8px;
}
</style>
